





































































































import { Component } from "vue-property-decorator";
import Header from "@/components/header/MLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckAdminLogin from "@/utils/CheckAdminLogin";
import { UpdateUser } from "@/api/lab-base-api-client";
import AdminsApi from "@/services/AdminsApi";
import UgcsApi from "@/services/Ugcs";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import AuthModule from "@/store/auth";
import { generateFileReader } from "@/utils/Util";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    Footer,
    CTooltip,
  },
})
export default class MRegisterInfoEdit extends CheckAdminLogin {
  private form: UpdateUser = {
    name: "",
    ugcUuid: "",
  };

  // img-input
  private image = [];

  // プレビューimgのurl
  private ugcUrl = "";

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // エラーモーダル表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  private async mounted() {
    this.fetch();
  }

  // アカウント情報の取得
  private async fetch() {
    // formにugcとnameをセット
    if (!this.me) {
      return;
    }
    this.form.name = this.me.name;
    this.form.ugcUuid = this.me.ugcUuid;
  }

  // 送信が押されたときupdateProfileを実行
  private async submit() {
    if (this.image && this.image.length === undefined) {
      const ugc = await this.createUgc();
      this.form.ugcUuid = ugc.uuid;
    }
    try {
      if (this.$route.name === "MRegisterInfoEdit") {
        await this.updateProfile();
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      console.log(err);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  // プロフィールを更新して完了ページに移動
  private async updateProfile() {
    if (!this.me) {
      return;
    }
    await AdminsApi.instance.updateAdminByUuid(this.me.uuid, this.form);
    // MRegisterInfoEditCompに進む
    this.$router.push({ name: "MRegisterInfoEditComp" });
  }

  // UGC作成
  private async createUgc() {
    try {
      const ugcRes = await UgcsApi.instance.createUGC(this.image);
      if (ugcRes.data.data?.ugc?.uuid === undefined) {
        logger.frontError("failed create ugc");
        throw new Error("failed create ugc");
      }
      return ugcRes.data.data.ugc;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
      console.log(err);
      throw err;
    }
  }

  /**
   * v-file-inputで選択したimageのプレビューを表示
   * 公式でchangeイベントの型はFile[]だが、ここでは単一のファイルしか使用しないためFileとして定義する
   */
  private previewFile(file: File) {
    if (!file) {
      this.ugcUrl = "";
    }
    const reader = generateFileReader(file);
    if (reader) {
      reader.addEventListener("load", () => {
        if (reader.result instanceof ArrayBuffer) {
          this.ugcUrl = reader.result.toString();
        } else if (reader.result) {
          this.ugcUrl = reader.result;
        }
      });
    }
  }
}
